import { LocalCostLabel } from "./local-cost-label.model";
import { LocationMapper } from "../../location/location.mapper";

export class LocalCostLabelMapper {
  public static map(data: any): LocalCostLabel {
    if (!data) {
      return null;
    }

    return new LocalCostLabel(
      data.label,
      LocationMapper.map({
        id: data.location.id,
        name: data.location.name,
      }),
    );
  }
}
